// BOTO NYC — configurator section.
// Tab-style selector that swaps which configuration panel (with 3 images)
// is visible. Keyboard-accessible (arrow keys move focus + activate).

(function () {
  document.querySelectorAll('[data-nodo-cfg]').forEach(function (cfg) {
    var tabs = Array.prototype.slice.call(cfg.querySelectorAll('[data-cfg-tab]'));
    var panels = Array.prototype.slice.call(cfg.querySelectorAll('[data-cfg-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach(function (t) {
        var match = t.dataset.cfgTab === id;
        t.classList.toggle('is-active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
        t.tabIndex = match ? 0 : -1;
      });
      panels.forEach(function (p) {
        var match = p.dataset.cfgPanel === id;
        p.classList.toggle('is-active', match);
        if (match) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(tab.dataset.cfgTab); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End')  next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          next.focus();
          activate(next.dataset.cfgTab);
        }
      });
    });
  });
})();
